import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import BasicDataPod from '../../../components/BasicDataPod';

import Link from '../../../components/BasicDataPod/Link';
import Icon from '../../../components/Icon';

import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.costs.need-met.title',
    defaultMessage: '100% of Need Met',
  },
  tooltip: {
    id: 'hubs.costs.need-met.tooltip',
    defaultMessage: `When a student can show the need for it, some colleges will help cover the entire cost of a student's education through grants, work-study, scholarships, and in some cases, federal student loans.`,
  },
  tooltipHeader: {
    id: 'hubs.costs.need-met.tooltip-header',
    defaultMessage: 'Meets 100% of Need',
  },
  linkText: {
    id: 'hubs.costs.need-met.link-text',
    defaultMessage: 'Learn more about financial aid',
  },
});

function NeedMet({ meetsFullFinancialNeeds, intl }) {
  return meetsFullFinancialNeeds ? (
    <BasicDataPod
      className="need-met"
      header={intl.formatMessage(messages.title)}
      tooltipHeader={intl.formatMessage(messages.tooltipHeader)}
      tooltip={intl.formatMessage(messages.tooltip)}
    >
      {meetsFullFinancialNeeds && (
        <Icon name="checkmark" className="need-met-checkmark" />
      )}
      <Link
        linkText={intl.formatMessage(messages.linkText)}
        linkUrl="Costs#financialaid"
      />
    </BasicDataPod>
  ) : null;
}

export default injectIntl(NeedMet);

NeedMet.propTypes = {
  meetsFullFinancialNeeds: PropTypes.bool,
  intl: PropTypes.object,
};
